<template>
  <div>
    <a-tabs :default-active-key="mode" @change="handleModel">
      <a-tab-pane key="wechat" tab="微信登录" v-if="wechat.url">
        <iframe :src="wechat.url" style="width: 100%; height: 500px; margin-left: auto; margin-right: auto;" v-if="mode === 'wechat'"></iframe>
      </a-tab-pane>
      <a-tab-pane key="email" tab="电子邮箱">
        <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }" v-if="mode === 'email'">
          <a-form-item label="电子邮箱">
            <a-input v-model="user.email"></a-input>
          </a-form-item>
          <a-form-item label="密码">
            <a-input type="password" v-model="user.password" maxlength="4" style="width: 200px;"></a-input>
          </a-form-item>
          <a-form-item label="验证码">
            <a-input v-model="user.code" maxlength="4" style="width: 100px;"></a-input>
            <img :src="user.image" style="width: 140px;" alt="点击刷新" @click="getRegCode"/>
          </a-form-item>
          <a-form-item label=" ">
            <a-button type="primary" icon="user" @click="auth" :loading="isLoading">登录</a-button>
          </a-form-item>
          <a-divider></a-divider>
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <a-button icon="user" style="background: #1AAD19; color: #FFFFFF; border-radius: 15px;" @click="changeReg()">去注册</a-button>
          </div>
        </a-form>
        <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }" v-else-if="mode === 'email-reg'">
          <a-form-item label="电子邮箱">
            <a-input v-model="user.email"></a-input>
          </a-form-item>
          <a-form-item label="验证码">
            <a-input v-model="user.code" maxlength="4" style="width: 100px;"></a-input>
            <img :src="user.image" style="width: 140px;" alt="点击刷新" @click="getRegCode"/>
          </a-form-item>
          <a-form-item label=" ">
            <a-button type="primary" icon="key" @click="reg()" :loading="isLoading">注册</a-button>
          </a-form-item>
          <a-divider></a-divider>
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <a-button type="primary" icon="user" style="border-radius: 15px;" @click="changeLogin()">去登录</a-button>
          </div>
        </a-form>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { baseMixin } from '@/libs/app-mixin'
import { getRegCode, userReg, authUser } from '@/api/user'
import { setToken } from '@/libs/util'

export default {
  name: 'LoginSection',
  mixins: [baseMixin],
  props: {
    wechat: {
      type: Object,
      default () {
        return {
          url: ''
        }
      }
    }
  },
  data () {
    return {
      mode: 'wechat',
      user: {
        email: '',
        password: '',
        code: '',
        code_en: '',
        image: ''
      },
      isLoading: false
    }
  },
  methods: {
    handleModel (e) {
      this.mode = e
    },
    changeReg () {
      this.getRegCode()
      this.mode = 'email-reg'
    },
    changeLogin () {
      this.getRegCode()
      this.mode = 'email'
    },
    getRegCode () {
      this.user.code_en = parseInt(Math.random() * 1000 + 1000) + '-' + parseInt(Math.random() * 1000 + 1000)
      getRegCode(this.user.code_en).then(res => {
        this.user.image = res.result.image
      })
    },
    reg () {
      if (this.user.email.length === 0) {
        this.$message.info('请输入验证码')
        return false
      }
      if (this.user.code.length !== 4) {
        this.$message.info('请输入验证码')
        return false
      }
      this.isLoading = true
      userReg({
        email: this.user.email,
        code: this.user.code,
        code_en: this.user.code_en
      }).then(res => {
        this.isLoading = false
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        this.$message.success('邮件发送成功，请根据邮件内容完成注册。')
      })
    },
    auth () {
      if (this.user.email.length === 0) {
        this.$message.info('请输入验证码')
        return false
      }
      if (this.user.password.length === 0) {
        this.$message.info('请输入密码')
        return false
      }
      if (this.user.code.length !== 4) {
        this.$message.info('请输入验证码')
        return false
      }
      authUser({
        email: this.user.email,
        password: this.user.password,
        code: this.user.code,
        code_en: this.user.code_en
      }).then(res => {
        this.isLoading = false
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        setToken(res.result.token)
        this.$message.success('登录成功')
        setTimeout(() => {
          location.href = '/'
        }, 3000)
      })
    }
  },
  mounted () {
    if (this.wechat.url === '') {
      this.mode = 'email'
    }
    this.getRegCode()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blocks/LoginSection.vue